/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/3/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import Legend from './Legend';
import Map from './Map/Map';

type Props = {
  models: Array<any>,
  performanceMetric: string,
}
const InventoryMap = ({ models, performanceMetric }: Props) => (
  <div>
    <Map
      wrapperHeight="700px"
      zoom={10}
      models={models}
      mapTypeId="satellite"
      performanceMetric={performanceMetric}
    />
    <Legend performanceMetric={performanceMetric} />
  </div>
);

export default InventoryMap;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryMap/InventoryMap.jsx